<template>

  <div>
    <div class="filterWrapper___1wvrf">
      <div class="filterItem___3bwcm">
        <span class="title___1vMKn">分类选择：</span>
        <div class="filterRight___24f-6">
          <span v-for="(item,index) in allList"
                :key="item"
                @click="egListTab(index)"
                class="itemText___1N3zE"
                :class="index==active?'itemActive___u02fW':''"
          >
            {{item}}
          </span>
        </div>
      </div>
      <div class="filterItem___3bwcm" v-if="active==1||active==2">
        <span class="title___1vMKn">选择：</span>
        <div class="filterRight___24f-6" v-if="active==1">
          <span v-for="(item,index) in menus"
                :key="item"
                @click="childTab(index)"
                class="itemText___1N3zE"
                :class="index==childindex?'itemActive___u02fW':''"
          >
          <span v-if="item!='会员'">{{item}}</span>
          </span>
        </div>
        <div v-if="active==2" class="filterRight___24f-6">
           <span v-for="(item,index) in menus"
                 :key="item"
                 @click="childTab(index)"
                 class="itemText___1N3zE"
                 :class="index==childindex?'itemActive___u02fW':''"
           >
            {{item}}
          </span>
        </div>
      </div>
    </div>
    <div class="me">
      <bespoke v-if="active==0"></bespoke>
      <collection v-if="active==1" :index="childindex"></collection>
      <div v-if="active==2">
        <!--<ul class="uls">-->
          <!--<li v-for="(item,val) in menus" @click="tabinfo(val)" :class="{'active':index==val}">{{item}}</li>-->
        <!--</ul>-->
        <div class="item_list" v-if="childindex==1">
          <div class="liveswill"
               v-for="(item,index) in pagelist_meet"
               :key="'liveswill'+index">

            <div class="con"
                 @click="toDetails(item.bId,item.orderType)">
              <div>
                <p class="con_author">订单编号：{{item.orderNo}}</p>
                <p class="con_author">下单时间：{{getTimes(item.createTime)}}</p>
              </div>
              <img class="con_images"
                   :src="item.url"
                   alt=""
                   v-if="item.url">
              <img class="con_images"
                   src="../../assets/images/default.png"
                   alt=""
                   v-else>
              <div class="con_right">
                <p class="con_title">{{item.title}}</p>
                <div>
                  <p class="con_author">{{item.eName}}</p>
                </div>
                <div>

                  <div class="con_bt">
                    <!--<span>参会人数：{{item.orderNum}}</span>-->
                    <span class="con_bt">
                      <span v-if="item.orderStatus==0">未支付</span>
                      <span v-if="item.orderStatus==1">已支付</span>
                      <span v-if="item.orderStatus==2">支付失败</span>
                      ￥{{item.payPrice}}

                    </span>
                    <!--<span class="con_bt_r" v-if="item.payPrice">-->
                      <!--<span>¥{{item.payPrice}}</span>-->
                    <!--</span>-->
                    <span class="con_bt_r"
                          style="font-size: 14px"
                         >
                      <span v-if="item.orderStatus==0">未支付</span>
                      <span v-if="item.orderStatus==1">支付成功</span>
                      <span v-if="item.orderStatus==2">支付失败</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nothing" v-if="pagelist_meet.length<1">
            <img  src="../../assets/images/nonelist.png" alt=""  >
            <p>暂无已购</p>
          </div>
        </div>
        <div class="container" v-if="childindex==0">
          <div class="item_list">
            <div v-if="pagelist_class.length>0"
                 class="liveswill"
                 v-for="(item,index) in pagelist_class"
                 :key="'liveswill'+index">
              <div class="con"
                   @click="toDetails(item.bId,item.orderType)">
                <div>
                  <p class="con_author">订单编号：{{item.orderNo}}</p>
                  <p class="con_author">下单时间：{{getTimes(item.createTime)}}</p>
                </div>
                <img class="con_images"
                     :src="item.url"
                     alt=""
                     v-if="item.url">
                <img class="con_images"
                     src="../../assets/images/default.png"
                     alt=""
                     v-else>
                <div class="con_right">
                  <p class="con_title">{{item.title}}</p>
                  <div>
                    <p class="con_author">{{item.speaker}}</p>
                  </div>

                  <div>

                    <div class="con_bt">
                      <!--<span>参会人数：{{item.orderNum}}</span>-->
                      <span class="con_bt">
                      <span v-if="item.orderStatus==0">未支付</span>
                      <span v-if="item.orderStatus==1">已支付</span>
                      <span v-if="item.orderStatus==2">支付失败</span>
                      ￥{{item.payPrice}}

                    </span>
                      <!--<span class="con_bt_r" v-if="item.payPrice">-->
                      <!--<span>¥{{item.payPrice}}</span>-->
                      <!--</span>-->
                      <span class="con_bt_r"
                            style="font-size: 14px;"
                      >
                      <span v-if="item.orderStatus==0">未支付</span>
                      <span v-if="item.orderStatus==1">支付成功</span>
                      <span v-if="item.orderStatus==2">支付失败</span>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="nothing" v-if="pagelist_class.length<1">
              <img  src="../../assets/images/nonelist.png" alt=""  >
              <p>暂无已购</p>
            </div>

          </div>

        </div>
        <div class="vip_list" v-if="childindex==2">
          <div class="item_list">
      <div>
      <el-table :data="pagelist_vip"
              style="width: 100%"
              align="center">
      <el-table-column 
                       label="会员类型"
                       align="center"
                       width="250"
                       prop="mname">
        <template slot-scope="scope">
          <div>购买CMDHRA 
            <span v-if="scope.row.type==1">个人会员 {{ scope.row.mname }}</span>
            
            <span v-if="scope.row.type==2">企业会员</span>
            </div>
        </template>
      </el-table-column>
      <el-table-column label="充值时间"
                       prop="purchaseTime"
                       min-width="100"
                       align="center">
        <template slot-scope="scope">
          <div>充值时间：{{ scope.row.purchaseTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="金额"
                       prop="mprice"
                       align="center"
                       min-width="50">
        <template slot-scope="scope">
          <div style="color:red">￥{{ scope.row.mprice }}</div>
        </template>
      </el-table-column>
    </el-table>
    </div>
            <!-- <div class="nothing" v-if="pagelist_vip.length<1">
              <img  src="../../assets/images/nonelist.png" alt=""  >
              <p>暂无已购</p>
            </div> -->

          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import grxx from '../../assets/images/grxx.png'
  import woyy from '../../assets/images/woyy.png'
  import wdsc from '../../assets/images/wdsc.png'
  import next from '../../assets/images/next.png'

  import bespoke from './bespoke'
  import collection from './collection'
import loginService from '../../plugin/extendFn/loginService'
import AppSetting from '../../AppSetting'
    export default {
        data() {
            return {
              menus:[
                '单课',
                '专栏',
                '会员',
              ],
              allList:[
                '我的预约',
                '我的收藏',
                '我的已购',
              ],
              index:0,
              active:0,
              pagelist_class:[],//单课
              pagelist_meet:[],//会议
              pagelist_vip:[],//会员
              wxuser:null,
              childindex:0,


            }
        },
        props: {},
      components:{
        bespoke,
        collection
      },
        methods: {
          childTab(index){
            this.childindex = index;
          },
          getTimes (value) {
            return new Date(value).Format("yyyy-MM-dd hh:mm");
          },
          tabinfo(index){
            this.index=  index;
          },
          toDetails(id,type){
            if(type==2){//直播

              if(this.isCharge){//需要付费
                this.$message.warning('当前课程不支持观看，请先参会')

              }else{
                this.$router.push({
                  name:"Details",
                  query:{type:"live",liveId:id}
                });
              }


            }else if(type==1){
              //视频
              if(this.isCharge){
                this.$message.warning('当前课程不支持观看，请先参会')
              }else{
                this.$router.push({
                  name:"vDetails",
                  query:{type:"video",videoId:id}
                });
              }

            }else if(type==3){
              //专栏详情
              this.$router.push({
                name: "colDetails",
                query: { type: "column", colId: id }
              });
              // window.location.reload()
            }
          },

          egListTab(index){
            this.childindex = 0;
            this.active=index;
            if(this.childindex==0){
              this.$postHttp(AppSetting.baseUrl + '/order/app/pageList',{orderType:1,uid:this.wxuser.uId}).then((res)=>{//单课
                this.pagelist_class = res.data.list;
              });
              this.$postHttp(AppSetting.baseUrl + '/order/app/pageList',{orderType:3,uid:this.wxuser.uId}).then((res)=>{//会议
                if(res.data.code==0){
                  this.pagelist_meet = res.data.list;
                }
              });
              this.$postHttp(AppSetting.baseUrl + '/memberitem/queryByUserMenberLog',{uId:this.wxuser.uId}).then((res)=>{//会员
                this.pagelist_vip = res.data.list;

              });

            }
          }

        },
        computed: {},
       async  mounted() {
        this.wxuser = await loginService.getLoginUser();

          this.$waiting.hide();
          this.sicon = this.wxuser?this.wxuser.uIcon?this.wxuser.uIcon:'':'';
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          // this.info()
        },

    }
</script>
<style scoped lang="scss">
  .me>div{
    width: 1280px;
  }
  .nothing{
    width: 1280px;
    min-width: 1280px;
    text-align: center;
    img{
      width: 100px;
      display: inline-block;
      margin: 80px auto 0px;
    }
    p{
      font-size: 16px;
      color: #999999;
      text-align: center;
    }

  }
  .uls{
    position: relative;
    margin-top: 10px;
    display: flex;
    width: 1280px;
    min-width: 1280px;
    border-bottom: 1px solid #E6E6E6;
    color: #666666;
    align-items: center;
    z-index: 1;
    li{
      width: 200px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      cursor: pointer;
    }
    li:nth-of-type(2){
      /*border-left: 1px solid #E6E6E6;*/
    }
    .active{
      color: #05a2ff;
      border-bottom: 1px solid #05a2ff;
    }
  }
  .con_bt {
    font-size: 12px;
    color: #999999;
    overflow: hidden;
    line-height: 30px;
    span:first-child {
      float: left;
    }
    s {
      font-size: 14px;
      color: #999999;
    }
  }
  .con_bt_r {
    font-size: 16px;
    float: right;
    color: #f00000;
  }
  .liveswill {
    border: 1px solid #e6e6e6;
    height: 320px !important;
    border-radius: 5px;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    width: 232px;
    cursor: pointer;
    padding: 0 10px;

    float: left;
    margin: 24px 24px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -ms-flex-pack: justify;
    -webkit-box-pack: justify;
    justify-content: flex-start;
    .con {
      margin-top: 6px;
      >div{
        margin-bottom: 5px;
      }
    }
    .con_images {
      width: 212px !important;
      height: 134px !important;
      border-radius: 5px !important;
    }
    .con_title {
      font-size: 14px !important;
      color: #333 !important;
      line-height: 18px !important;
      height: 39px !important;
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 2; /*限制文本行数*/
      /*white-space: nowrap;      !*超出的空白区域不换行*!*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*文本超出显示省略号*/
    }

    .con_author {
      font-size: 12px !important;
      font-weight: 300 !important;
      color: #666666 !important;
      min-height: 14px !important;
      margin-top: 5px !important;
    }
    .last {
      padding: 0px !important;
      box-sizing: border-box !important;
      margin-top: 6px !important;
      height: 20px;
    }
  }

  .me{
    min-width: 1280px;
    margin: 0 auto;
  }
  .item_list {
    overflow: hidden;
    margin-bottom: 20px;
  }
  .filterWrapper___1wvrf {
    margin-bottom: 20px;
    background: #fff;
    -webkit-box-shadow: 0 3px 5px rgba(0, 0, 0, 0.08);
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.08);
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
  }
  .filterItem___3bwcm {
    width: 1280px;
    min-width: 1176px;
    border-bottom: 1px dashed #ebebeb;
    overflow: hidden;
    display: -ms-flexbox;
    display: flex;
    padding: 5px 0 5px;
    .title___1vMKn {
      font-size: 14px;
      float: left;
      line-height: 38px;
      color: #999;
      min-width: 70px;
      height: 30px;
      margin-right: 25px;
    }
    .filterRight___24f-6 {
      float: left;
      line-height: 38px;
      span {
        font-size: 14px;
        cursor: pointer;
        padding: 2px 12px;
      }
    }
    .itemText___1N3zE {
      min-height: 30px;
      color: #333;
      margin-right: 8px;
      cursor: pointer;
    }
    .itemActive___u02fW {
      border-radius: 16px;
      background-color: #05a2ff;
      color: #fff;
      text-align: center;
    }
  }
  .search___1FrwO {
    position: relative;
    width: 296px;
    height: 36px;
    border-radius: 18px;
    /*background: #f2f2f2;*/
    background: #ffffff;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    .searchBox___joiqa {
      outline: none;
      border: none;
      -ms-flex: 1 1;
      flex: 1 1;
      /*background: #f2f2f2;*/
      background: #ffffff;
      height: 36px;
      padding-left: 27px;
      font-size: 14px;
      color: #999;
      line-height: 20px;
      border-radius: 18px;
      -webkit-appearance: none;
    }
    .iconWrapper___3GNet {
      cursor: pointer;
      width: 56px;
      height: 36px;
      background-image: linear-gradient(-179deg, #ffb441, #ffb441);
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
      border-top-right-radius: 18px;
      border-bottom-right-radius: 18px;
      .icon {
        font-size: 26px;
      }
      img {
        width: 20px;
        height: 20px;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/me/index.vue